import { render, staticRenderFns } from "./FormularioRegistro.vue?vue&type=template&id=a3c52f50"
import script from "./FormularioRegistro.vue?vue&type=script&lang=js"
export * from "./FormularioRegistro.vue?vue&type=script&lang=js"
import style0 from "./FormularioRegistro.vue?vue&type=style&index=0&id=a3c52f50&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports